import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import styles from './Clan.scss'

const Clan = (props) => (
    <div className={cx(styles.base, props.className)}>
        <img className={styles.emblem} src={props.emblem} />
        <div className={styles.tagName} style={{ color: props.color }}>{`[${props.tag}]`}</div>
        <div className={styles.clanName}>{props.name}</div>
    </div>
)

Clan.propTypes = {
    tag: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    emblem: PropTypes.string.isRequired,
    className: PropTypes.string,
}

export default Clan



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/components/Clan/Clan.jsx